import { ICalendar } from "../../../domain/calendars/ICalendar";
import { mapCalendarEvents } from './mapEmployeeAbsenceInfo';

export const mapCalendar = (x: any): ICalendar => ({
    id: x.id,
    name: x.name,
    userType: x.userType,
    calendarEvents: x.calendarEvents.map(mapCalendarEvents),
    status: x.status,
    meetingEnd: x.meetingEnd
});
